<!--
View Dialog Field with three buttons and possible alert.
Extremely similar to TwoButtonDialog, but used very rarely.
-->
<template>
  <v-dialog v-model="showDialog" persistent width="unset">
    <v-alert v-if="showAlert" :type="alertType" class="mb-0">
      {{ alertText }}
    </v-alert>
    <!-- Unexpected useless attribute on `<template>`  vue/no-useless-template-attributes
     @TODO check class="pa-0" -->
    <template v-if="!hideButton" v-slot:activator="{on}">
      <v-btn
          rounded
          :color="color"
          class="mr-3 mb-3 mb-md-0 white--text"
          v-on="on"
          elevation="0"
      >{{ btnText }}
      </v-btn>
    </template>
    <v-card class="ma-0">
      <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
      <v-card-subtitle class="pb-0" v-if="subtitleText">{{ subtitleText }}</v-card-subtitle>
      <v-card outlined class="ma-5" v-if="addInfoText">
        <v-card-text>
          <p v-html="addInfoText"></p>
        </v-card-text>
      </v-card>
      <v-card-text v-if="addTextField">
        <v-container>
          <v-text-field
              v-model="textField"
              :label="addTextFieldLabel"
              outlined
          />
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        {{ dialogText }}

        <!-- Animated dotts -->
        <div v-if="animate" class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row justify="end" class="ma-0">
          <v-col>
            <v-btn
                v-if="!hideFirstButton"
                :disabled="button1Disabled"
                :loading="button1Loading"
                color="primary"
                @click="clickedButton1()"
            >{{ button1Text }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
                v-if="!hideSecondButton"
                :disabled="button2Disabled"
                :loading="button2Loading"
                color="error"
                @click="clickedButton2()"
            >{{ button2Text }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
                v-if="!hideThirdButton"
                :disabled="button3Disabled"
                :loading="button3Loading"
                color="grey"
                @click="clickedButton3()"
            >{{ button3Text }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ThreeButtonDialog",
  props: {
    btnText: String,
    color: String,
    dialogTitle: String,
    dialogText: String,
    button1Text: String,
    button2Text: String,
    button3Text: String,
    hideButton: Boolean,
    hideFirstButton: Boolean,
    hideSecondButton: Boolean,
    hideThirdButton: Boolean,
    subtitleText: String,
    addInfoText: String,
    animate: Boolean,
    addTextField: Boolean,
    addTextFieldLabel: String
  },
  data() {
    return {
      showDialog: false,
      button1Loading: false,
      button2Loading: false,
      button3Loading: false,
      button1Disabled: false,
      button2Disabled: false,
      button3Disabled: false,
      showAlert: false,
      alertText: "",
      alertType: "",
      textField: "",
      propToGiveThrough: null,
      toRoute: String,
    }
  },
  methods: {
    clickedButton1() {
      if(this.propToGiveThrough) {
        this.$emit('clickedButton1', this.propToGiveThrough);
      } else {
        this.$emit('clickedButton1');
      }
    },
    clickedButton2() {
      if(this.propToGiveThrough) {
        this.$emit('clickedButton2', this.propToGiveThrough);
      } else {
        this.$emit('clickedButton2');
      }
    },
    clickedButton3() {
      if(this.propToGiveThrough) {
        this.$emit('clickedButton3', this.propToGiveThrough);
      } else {
        this.$emit('clickedButton3');
      }
    },
    setButtonSettings(button1Loading, button1Disabled, button2Loading, button2Disabled, button3Loading, button3Disabled) {
      this.button1Loading = button1Loading;
      this.button1Disabled = button1Disabled;
      this.button2Loading = button2Loading;
      this.button2Disabled = button2Disabled;
      this.button3Loading = button3Loading;
      this.button3Disabled = button3Disabled;
    },
    setAlertSettings(type, text, show) {
      this.alertType = type;
      this.alertText = text;
      this.showAlert = show;
    },
    resetSettings() {
      this.setButtonSettings(false, false, false, false, false, false);
      this.showDialog = false;
      this.setAlertSettings("", "", false);
    }
  }
}
</script>
<style src="@/modules/core/components/TwoButtonDialog/TwoButtonDialog.scss" lang="scss"/>
